import React from 'react';
import classes from './Aboute.module.scss'
import Navbar from "../Navbar/Navbar";
import Fotter from "../Fotter/Fotter";

function Aboute() {
    return (
        <div className={classes['abooute']}>
            <div className={classes['bg']}></div>
            <div className={classes['aboute-section']}>
                <Navbar/>
                <div className={classes['aboute-container']}>

                    <div>
                        <h1 className={classes['header']}>ABOUT US</h1>
                        <p className={classes['paragraph']}>INDUSTRIAL SECTOR</p>
                    </div>


                    <div className={classes['childs-sections']}>
                        <div><p>Production of products from
                            composite materials.</p></div>
                        <div><p>Green energy (design and
                            production of wind farms).</p></div>
                        <div><p>Design and production of control
                            and stabilization systems.</p></div>
                        <div><p>Design and manufacture of UAVs.</p></div>
                        <div><p>Rendering of engineering services.</p></div>
                        <div><p>Robotics</p></div>
                    </div>


                    <div className={classes['paragraphs-section']}>
                        <h6>OUR MISSION</h6>
                        <h2>WE STARTED THIS WAY SINCE 2016</h2>
                        <p>Creation of the company occupying the world’s leader position in
                            the field of aircraft engineering and robotics and having an effective
                            impact on creation of scientific-based economy of Republic of Armenia.</p>
                    </div>


                    <div className={classes['goals']}>
                        {/*<div className={classes['img']}></div>*/}
                        <div className={classes['texts']}>
                            <h2>GOALS</h2>
                            <p>Development of effective air and ground robots and control systems for use in various
                                fields
                                of human activity through a combination of innovative technologies, products of
                                modern scientific research and the experience of qualified professionals.
                                <br/>
                                Provision of qualified consulting services in the field of aircraft engineering,
                                robotics.
                                Stimulation of the fundamental scientific direction connected with the field of the
                                company activity, by creating a common platform for scientific research, both local
                                and foreign scientific and educational organizations.Ensuring product competitiveness
                                of the company and stable growth of the sphere of the provided services.</p>
                        </div>

                    </div>


                    <div className={classes['texts-two']}>
                        <h2>ALL DESIGN LEVELS SUPPORT </h2>
                        <p>The company provides support at all stages of the design of parts,
                            devices and systems of varying complexity. We have been involved in
                            projects involving communications for wind energy, optimization of
                            metal structures for critical systems, design of radar antenna fairings,
                            and civil infrastructure design. We offer services such as:
                            <br/>
                            <br/>
                            • Conceptual design
                            <br/>

                            • Strength analysis
                            <br/>

                            • Creation of 3D models
                            <br/>

                            • Drawing creation
                            <br/>

                            • Creation of technical documentation</p>
                    </div>

                </div>
                <Fotter/>

            </div>
        </div>
    );
}

export default Aboute;